import { forwardRef, useRef } from '@wordpress/element';
import { useMergeRefs } from '@wordpress/compose';
import deprecated from '@wordpress/deprecated';
import { ControlWithError } from '@wordpress/ui';
import TextareaControl from '../../textarea-control';
import { jsx as _jsx } from "react/jsx-runtime";
const UnforwardedValidatedTextareaControl = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  deprecated('wp.components.privateApis.ValidatedTextareaControl', {
    since: '7.2',
    alternative: 'ValidatedTextareaControl from @wordpress/ui',
    hint: 'This private API will be completely removed within a few Gutenberg plugin releases.'
  });
  const validityTargetRef = useRef(null);
  const mergedRefs = useMergeRefs([forwardedRef, validityTargetRef]);
  return /*#__PURE__*/_jsx(ControlWithError, {
    className: "components-validated-control",
    required: required,
    markWhenOptional: markWhenOptional,
    customValidity: customValidity,
    getValidityTarget: () => validityTargetRef.current,
    children: /*#__PURE__*/_jsx(TextareaControl, {
      ref: mergedRefs,
      ...restProps
    })
  });
};
export const ValidatedTextareaControl = forwardRef(UnforwardedValidatedTextareaControl);
ValidatedTextareaControl.displayName = 'ValidatedTextareaControl';